var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info",class:{
    'info-horizontal': _vm.infoHorizontal,
    'text-right': _vm.textRight,
    'text-left': _vm.textLeft,
    'text-center': _vm.textCenter
  }},[_c('div',{staticClass:"icon",class:_vm.infoColor},[_c('md-icon',[_vm._v(_vm._s(_vm.icon))])],1),(!_vm.infoHorizontal)?[_vm._t("header"),_vm._t("title"),_vm._t("content")]:[_vm._t("header"),_c('div',{staticClass:"description"},[_vm._t("title"),_vm._t("content")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }